import React from 'react';
import Card from '../../components/common/Card';
import PresentationThemeList from './components/PresentationThemeList';

function PresentationTheme(): JSX.Element {
    return (
        <Card>
            <PresentationThemeList />
        </Card>
    );
}

export default PresentationTheme;
